import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';

export class SmokeLayer extends BaseProduct {
  public readonly id: ProductId = 'smoke';

  protected onActivate(): void {
    this.refresh();
  }

  protected onDeactivate(): void {
    const levels = ['surface', 'column'];
    levels.forEach(level => {
      this.layerManager.removeBufferedRasterLayer(`${this.id}-${level}`);
    });
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(targetTimeMs?: number) {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const model = state.smokeModel || state.selectedModels?.['smoke'] || 'raqdps';
    const opacity = getLayerOpacity(this.id, 1.0);
    const current = targetTimeMs !== undefined ? targetTimeMs : state.currentTimeStep;
    if (!current) return;

    const activeLevels = state.smokeLevels || ['surface'];
    const allLevels = ['surface', 'column'];

    allLevels.forEach(level => {
      const subLayerId = `${this.id}-${level}`;
      const hasLevelInManifest = Boolean(manifest.smoke?.available_by_model?.[model]?.[level]);
      if (state.smokeEnabled && activeLevels.includes(level) && hasLevelInManifest) {
        const ok = this.updateStandardInterpolatedRaster({
          layerId: subLayerId,
          product: this.id,
          model,
          targetTime: current,
          opacity,
          minzoom: 0,
          maxzoom: 5,
          formatHour: (dateStr, cleanHourStr) => `${level}_${dateStr}_Z${cleanHourStr}`
        });
        if (!ok) {
          this.layerManager.removeBufferedRasterLayer(subLayerId);
        }
      } else {
        this.layerManager.removeBufferedRasterLayer(subLayerId);
      }
    });
  }
}
export default SmokeLayer;
